import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-dm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-dm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsDmConstants } from "./create-application-details-dm.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsDmComponent = class CreateApplicationDetailsDmComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    detailsFormGroupName = CreateApplicationDetailsDmConstants.DETAILS_FORM_GROUP_NAME;
    applicationTypeCtrl = CreateApplicationDetailsDmConstants.TYPE_CTRL;
    applicationTypeLbl = CreateApplicationDetailsDmConstants.TYPE_LBL;
    descriptionCtrl = CreateApplicationDetailsDmConstants.DESCRIPTION_CTRL;
    descriptionLbl = CreateApplicationDetailsDmConstants.DESCRIPTION_LBL;
    validationMessages = CreateApplicationDetailsDmConstants.VALIDATION_MESSAGES;
    applicationTypePlaceHolder = CreateApplicationDetailsDmConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    detailsForm;
    title = "";
    selectedApplicationDmSubscription;
    getLookupsObservableSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookup();
        this.getMetadata();
        this.subscribeToSelectedApplication();
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDmSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
    }
    loadLookup() {
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'ApplicationType' and deleted eq false` }).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                this.applicationTypes.push(JSON.parse(lp.content));
            });
            this.applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
            this.changeDetectorRefs.detectChanges();
        });
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsDmComponent = __decorate([
    Component({
        selector: "app-create-application-details-dm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsDmComponent);
export { CreateApplicationDetailsDmComponent };
